import Immutable from 'immutable';

const initialState = Immutable.Map();

function showLoadingStarted(state, payload) {
  return state.setIn([payload.id.toString(), 'loading'], true);
}

function showLoadingCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
  state.setIn([payload.id.toString(), 'errors'], false);
  return stopShowLoading(state, payload);
}

function showLoadingCached(state, payload) {
  return stopShowLoading(state, { id: payload.id });
}

function showLoadingFailed(state, payload) {
  state.setIn([payload.id.toString(), 'errors'], true);
  return stopShowLoading(state, payload);
}

function stopShowLoading(state, payload) {
  return state.mergeIn([payload.id.toString(), 'loading'], false);
}

function priceBreakdownStarted(state, payload) {
  state.setIn([payload.booking_id.toString(), 'price_breakdown', 'record'], {});
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'completed'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'loading'],
    true
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'failed'],
    false
  );
  state.setIn([payload.booking_id.toString(), 'price_breakdown', 'errors'], {});
  return state;
}

function priceBreakdownCompleted(state, payload) {
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'record'],
    Immutable.fromJS(payload)
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'completed'],
    true
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'loading'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'failed'],
    false
  );
  state.setIn([payload.booking_id.toString(), 'price_breakdown', 'errors'], {});
  return state;
}

function priceBreakdownFailed(state, payload) {
  state.setIn([payload.booking_id.toString(), 'price_breakdown', 'record'], {});
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'completed'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'loading'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_breakdown', 'failed'],
    true
  );
  state.setIn(
    [payload.id.toString(), 'price_breakdown', 'errors'],
    payload.errors
  );
  return state;
}

function pricePreviewStarted(state, payload) {
  state.setIn([payload.booking_id.toString(), 'price_preview', 'record'], null);
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'completed'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'loading'],
    true
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'failed'],
    false
  );
  state.setIn([payload.booking_id.toString(), 'price_preview', 'errors'], {});
  return state;
}

function pricePreviewCompleted(state, payload) {
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'record'],
    Immutable.fromJS(payload)
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'completed'],
    true
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'loading'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'failed'],
    false
  );
  state.setIn([payload.booking_id.toString(), 'price_preview', 'errors'], {});
  return state;
}

function pricePreviewFailed(state, payload) {
  state.setIn([payload.booking_id.toString(), 'price_preview', 'record'], {});
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'completed'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'price_preview', 'loading'],
    false
  );
  state.setIn([payload.booking_id.toString(), 'price_preview', 'failed'], true);
  state.setIn(
    [payload.bookind_id.toString(), 'price_preview', 'errors'],
    payload.errors
  );
  return state;
}

function sendNotificationStarted(state, payload) {
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'completed'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'loading'],
    true
  );
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'failed'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'errors'],
    {}
  );
  return state;
}

function sendNotificationCompleted(state, payload) {
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'completed'],
    true
  );
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'loading'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'failed'],
    false
  );
  state.setIn(
    [payload.booking_id.toString(), 'send_notification', 'errors'],
    {}
  );
  return state;
}

function sendNotificationFailed(state, payload) {
  const p = payload.responseJSON;
  state.setIn(
    [p.booking_id.toString(), 'send_notification', 'completed'],
    false
  );
  state.setIn([p.booking_id.toString(), 'send_notification', 'loading'], false);
  state.setIn([p.booking_id.toString(), 'send_notification', 'failed'], true);
  state.setIn(
    [p.booking_id.toString(), 'send_notification', 'errors'],
    payload.errors
  );
  return state;
}

function updateLoadingStarted(state, payload) {
  state.setIn([payload.id.toString(), 'update', 'completed'], false);
  state.setIn([payload.id.toString(), 'update', 'loading'], true);
  state.setIn([payload.id.toString(), 'update', 'failed'], false);
  state.setIn([payload.id.toString(), 'errors'], {});
  return state;
}

function updateLoadingCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
  state.setIn([payload.id.toString(), 'update', 'completed'], true);
  state.setIn([payload.id.toString(), 'update', 'failed'], false);
  state.setIn([payload.id.toString(), 'errors'], {});
  return stopUpdateLoading(state, payload);
}

function updateLoadingFailed(state, payload) {
  state.setIn([payload.id.toString(), 'update', 'completed'], false);
  state.setIn([payload.id.toString(), 'update', 'failed'], false);
  state.setIn([payload.id.toString(), 'errors'], payload.errors);
  return stopUpdateLoading(state, payload);
}

function stopUpdateLoading(state, payload) {
  return state.mergeIn([payload.id.toString(), 'update', 'loading'], false);
}

function pricingLoadingStarted(state, payload) {
  return state.mergeIn([payload.id.toString(), 'pricing'], { loading: true });
}

function pricingLoadingCompleted(state, payload) {
  state.mergeIn([payload.id.toString(), 'pricing'], {
    record: Immutable.fromJS(payload.response),
    isLoaded: true,
    error: false,
  });
  return stopShowPricingLoading(state, payload);
}

function pricingLoadingCached(state, payload) {
  return stopShowPricingLoading(state, { id: payload.id, isLoaded: true });
}

function pricingLoadingFailed(state, payload) {
  state.mergeIn([payload.id.toString(), 'pricing'], {
    error: true,
    isLoaded: false,
  });
  return stopShowPricingLoading(state, payload);
}

function stopShowPricingLoading(state, payload) {
  return state.mergeIn([payload.id.toString(), 'pricing'], { loading: false });
}

function sendMessageStarted(state, payload) {
  state.setIn([payload.booking_id.toString(), 'sendMessage', 'loading'], true);
  state.setIn([payload.booking_id.toString(), 'sendMessage', 'error'], false);
  state.setIn(
    [payload.booking_id.toString(), 'sendMessage', 'completed'],
    false
  );
  return state;
}

function sendMessageCompleted(state, payload) {
  state.setIn([payload.booking_id.toString(), 'sendMessage', 'loading'], false);
  state.setIn([payload.booking_id.toString(), 'sendMessage', 'error'], false);
  state.setIn(
    [payload.booking_id.toString(), 'sendMessage', 'completed'],
    true
  );
  if (payload.guest_email) {
    state.setIn(
      [payload.booking_id.toString(), 'record', 'tourist', 'email'],
      payload.guest_email
    );
  }

  if (payload.guest_firstname && payload.guest_lastname) {
    state.setIn(
      [payload.booking_id.toString(), 'record', 'tourist', 'first_name'],
      payload.guest_firstname
    );
    state.setIn(
      [payload.booking_id.toString(), 'record', 'tourist', 'last_name'],
      payload.guest_lastname
    );
    state.setIn(
      [payload.booking_id.toString(), 'record', 'tourist', 'name'],
      `${payload.guest_firstname} ${payload.guest_lastname}`
    );
  }

  return state;
}

function sendMessageFailed(state, payload) {
  state.setIn([payload.booking_id.toString(), 'sendMessage', 'loading'], false);
  state.setIn([payload.booking_id.toString(), 'sendMessage', 'error'], true);
  state.setIn(
    [payload.booking_id.toString(), 'sendMessage', 'completed'],
    false
  );
  return state;
}

function alterStarted(state, payload) {
  state.setIn([payload.id.toString(), 'alter', 'loading'], true);
  state.setIn([payload.id.toString(), 'alter', 'error'], false);
  state.setIn([payload.id.toString(), 'alter', 'completed'], false);
  state.setIn([payload.id.toString(), 'alter', 'errors'], {});
  return state;
}

function alterCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'alter', 'error'], false);
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
  state.setIn([payload.id.toString(), 'alter', 'loading'], false);
  state.setIn([payload.id.toString(), 'alter', 'completed'], true);
  return state;
}

function alterFailed(state, payload) {
  state.setIn([payload.id.toString(), 'alter', 'error'], true);
  state.setIn([payload.id.toString(), 'alter', 'loading'], false);
  state.setIn([payload.id.toString(), 'alter', 'completed'], false);
  state.setIn(
    [payload.id.toString(), 'alter', 'errors'],
    Immutable.fromJS(payload)
  );
  return state;
}

function resetAlterFailed(state, payload) {
  state.setIn([payload.id.toString(), 'alter', 'error'], false);
  state.setIn([payload.id.toString(), 'alter', 'errors'], {});
}

function acceptStarted(state, payload) {
  state.setIn([payload.id.toString(), 'accept', 'error'], false);
  state.setIn([payload.id.toString(), 'accept', 'loading'], true);
  return state.setIn([payload.id.toString(), 'accept', 'completed'], false);
}

function acceptFailed(state, payload) {
  state.setIn([payload.id.toString(), 'accept', 'error'], true);
  state.setIn([payload.id.toString(), 'accept', 'loading'], false);
  return state.setIn([payload.id.toString(), 'accept', 'completed'], false);
}

function acceptCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'accept', 'error'], false);
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
  state.setIn([payload.id.toString(), 'accept', 'loading'], false);
  return state.setIn([payload.id.toString(), 'accept', 'completed'], true);
}

function rejectStarted(state, payload) {
  state.setIn([payload.id.toString(), 'reject', 'loading'], true);
  state.setIn([payload.id.toString(), 'reject', 'error'], false);
  state.setIn([payload.id.toString(), 'reject', 'completed'], false);
}

function rejectCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'reject', 'loading'], false);
  state.setIn([payload.id.toString(), 'reject', 'error'], false);
  state.setIn([payload.id.toString(), 'reject', 'completed'], true);
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
}

function rejectFailed(state, payload) {
  state.setIn([payload.id.toString(), 'reject', 'loading'], false);
  state.setIn([payload.id.toString(), 'reject', 'completed'], false);
  state.setIn([payload.id.toString(), 'reject', 'error'], true);
}

function cancelStarted(state, payload) {
  state.setIn([payload.id.toString(), 'cancel', 'loading'], true);
  state.setIn([payload.id.toString(), 'cancel', 'completed'], false);
  state.setIn([payload.id.toString(), 'cancel', 'error'], false);
  return state;
}

function cancelCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'cancel', 'loading'], false);
  state.setIn([payload.id.toString(), 'cancel', 'completed'], true);
  state.setIn([payload.id.toString(), 'cancel', 'error'], false);
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
  return state;
}

function cancelFailed(state, payload) {
  state.setIn([payload.id.toString(), 'cancel', 'loading'], false);
  state.setIn([payload.id.toString(), 'cancel', 'completed'], false);
  state.setIn([payload.id.toString(), 'cancel', 'error'], true);

  if (payload.responseJSON && payload.responseJSON.code) {
    state.setIn(
      [payload.id.toString(), 'cancel', 'errorCode'],
      payload.responseJSON.code.toString()
    );

    if (payload.responseJSON.code === 'already_cancelled') {
      state.setIn([payload.id.toString(), 'cancel', 'loading'], true);
    }
  }

  return state;
}

function updateGuestStarted(state, payload) {
  state.setIn([payload.id.toString(), 'updateGuest', 'loading'], true);
  return state.setIn([payload.id.toString(), 'guestUpdated'], false);
}

function updateGuestCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'updateGuest', 'loading'], false);
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
  state.setIn([payload.id.toString(), 'guestUpdated'], true);
  return state;
}

function updateGuestFailed(state, payload) {
  state.setIn([payload.id.toString(), 'updateGuest', 'loading'], false);
  state.setIn([payload.id.toString(), 'guestUpdated'], false);
  return state;
}

function updateAdditionalGuestsStarted(state, payload) {
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'loading'],
    true
  );
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'completed'],
    false
  );
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'error'],
    false
  );
  return state;
}

function updateAdditionalGuestsCompleted(state, payload) {
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'loading'],
    false
  );
  state.setIn([payload.id.toString(), 'record'], Immutable.fromJS(payload));
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'completed'],
    true
  );
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'error'],
    false
  );
  return state;
}

function updateAdditionalGuestsFailed(state, payload) {
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'loading'],
    false
  );
  state.setIn(
    [payload.id.toString(), 'updateAdditionalGuests', 'completed'],
    false
  );
  state.setIn([payload.id.toString(), 'updateAdditionalGuests', 'error'], true);
  return state;
}

function paymentsStarted(state, payload) {
  state.setIn([payload.id.toString(), 'payments', 'loading'], true);
  state.setIn([payload.id.toString(), 'payments', 'error'], false);
}

function paymentsFailed(state, payload) {
  state.setIn([payload.id.toString(), 'payments', 'loading'], false);
  state.setIn([payload.id.toString(), 'payments', 'error'], true);
}

function paymentsCompleted(state, payload) {
  state.setIn([payload.id.toString(), 'payments', 'loading'], false);
  state.setIn([payload.id.toString(), 'payments', 'error'], false);
  state.setIn(
    [payload.id.toString(), 'payments', 'records'],
    Immutable.fromJS(payload.bookings)
  );
}

function invoiceGuestStarted(state, _payload) {
  state.setIn(['invoiceGuest', 'failed'], false);
  state.setIn('loading', true);
}

function invoiceGuestCompleted(state, _payload) {
  state.setIn(['invoiceGuest', 'completed'], true);
  state.setIn(['invoiceGuest', 'failed'], false);
  state.setIn('loading', false);
  return state;
}

function invoiceGuestFailed(state, _payload) {
  state.setIn(['invoiceGuest', 'completed'], false);
  state.setIn(['invoiceGuest', 'failed'], true);
  state.setIn('loading', false);
  return state;
}

function invoiceGuestReset(state, _payload) {
  state.setIn(['invoiceGuest', 'completed'], false);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        BOOKINGS_SHOW: showLoadingStarted,
        BOOKINGS_SHOW_COMPLETED: showLoadingCompleted,
        BOOKINGS_SHOW_CACHED: showLoadingCached,
        BOOKINGS_SHOW_FAILED: showLoadingFailed,
        BOOKINGS_UPDATE: updateLoadingStarted,
        BOOKINGS_UPDATE_COMPLETED: updateLoadingCompleted,
        BOOKINGS_UPDATE_FAILED: updateLoadingFailed,
        BOOKINGS_LOAD_PRICING: pricingLoadingStarted,
        BOOKINGS_LOAD_PRICING_COMPLETED: pricingLoadingCompleted,
        BOOKINGS_LOAD_PRICING_CACHED: pricingLoadingCached,
        BOOKINGS_LOAD_PRICING_FAILED: pricingLoadingFailed,
        BOOKINGS_SEND_MESSAGE: sendMessageStarted,
        BOOKINGS_SEND_MESSAGE_COMPLETED: sendMessageCompleted,
        BOOKINGS_SEND_MESSAGE_FAILED: sendMessageFailed,
        BOOKINGS_ALTER: alterStarted,
        BOOKINGS_ALTER_COMPLETED: alterCompleted,
        BOOKINGS_ALTER_FAILED: alterFailed,
        BOOKINGS_RESET_ALTER_FAILED: resetAlterFailed,
        BOOKINGS_ACCEPT: acceptStarted,
        BOOKINGS_ACCEPT_COMPLETED: acceptCompleted,
        BOOKINGS_ACCEPT_FAILED: acceptFailed,
        BOOKINGS_REJECT: rejectStarted,
        BOOKINGS_REJECT_COMPLETED: rejectCompleted,
        BOOKINGS_REJECT_FAILED: rejectFailed,
        BOOKINGS_CANCEL: cancelStarted,
        BOOKINGS_CANCEL_COMPLETED: cancelCompleted,
        BOOKINGS_CANCEL_FAILED: cancelFailed,
        BOOKINGS_UPDATE_GUEST: updateGuestStarted,
        BOOKINGS_UPDATE_GUEST_COMPLETED: updateGuestCompleted,
        BOOKINGS_UPDATE_GUEST_FAILED: updateGuestFailed,
        BOOKINGS_UPDATE_ADDITIONAL_GUESTS: updateAdditionalGuestsStarted,
        BOOKINGS_UPDATE_ADDITIONAL_GUESTS_COMPLETED:
          updateAdditionalGuestsCompleted,
        BOOKINGS_UPDATE_ADDITIONAL_GUESTS_FAILED: updateAdditionalGuestsFailed,
        BOOKINGS_PRICE_BREAKDOWN: priceBreakdownStarted,
        BOOKINGS_PRICE_BREAKDOWN_COMPLETED: priceBreakdownCompleted,
        BOOKINGS_PRICE_BREAKDOWN_FAILED: priceBreakdownFailed,
        BOOKINGS_PRICE_PREVIEW: pricePreviewStarted,
        BOOKINGS_PRICE_PREVIEW_COMPLETED: pricePreviewCompleted,
        BOOKINGS_PRICE_PREVIEW_FAILED: pricePreviewFailed,
        BOOKINGS_SEND_NOTIFICATION: sendNotificationStarted,
        BOOKINGS_SEND_NOTIFICATION_COMPLETED: sendNotificationCompleted,
        BOOKINGS_SEND_NOTIFICATION_FAILED: sendNotificationFailed,
        BOOKINGS_PAYMENTS: paymentsStarted,
        BOOKINGS_PAYMENTS_COMPLETED: paymentsCompleted,
        BOOKINGS_PAYMENTS_FAILED: paymentsFailed,
        BOOKING_INVOICE_GUEST: invoiceGuestStarted,
        BOOKING_INVOICE_GUEST_COMPLETED: invoiceGuestCompleted,
        BOOKING_INVOICE_GUEST_FAILED: invoiceGuestFailed,
        BOOKING_INVOICE_GUEST_RESET: invoiceGuestReset,
      }[type] || (() => state)
    )(state, payload);
  });
}
